export const filterLiveArticles = (articles: InboxArticle[]) =>
    articles.filter(({ livestreamEndDate, livestreamStartDate, type }) => {
        if (type !== "liveStreamCommunityEntry") return true;

        if (!livestreamEndDate || !livestreamStartDate) {
            return true; // TODO is this correct
        }

        const now = Date.now();

        return !(livestreamStartDate > now || now > livestreamEndDate);
    });
